module.exports = __webpack_public_path__ + "02_long_grey.9d42f536.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer5/02_long_grey.png
// module id = KmzR
// module chunks = 0